import { render, staticRenderFns } from "./orgsquad.vue?vue&type=template&id=5083e2a5"
import script from "./orgsquad.vue?vue&type=script&lang=js"
export * from "./orgsquad.vue?vue&type=script&lang=js"
import style0 from "./orgsquad.vue?vue&type=style&index=0&id=5083e2a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports